import React, { useEffect } from 'react';
import { Drawer, Popconfirm, Button } from 'antd';
import { useToggle } from 'react-use';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import differenceBy from 'lodash/differenceBy';

import AddDevicesDrawer from './AddDevicesDrawer';
import CalendarDeviceItem from './CalendarDeviceItem';

function CalendarDevicesList({
  t,
  allDevices,
  devices,
  visible,
  onAdd,
  onClose,
  onDelete,
  onFetchDevices,
  onDeleteAllDevices,
  onDeletePlaylistFromCalendar,
  onSearch,
  onFilter,
  filter,
  filters,
}) {
  const [isOpen, toggle] = useToggle(false);

  useEffect(() => {
    if (visible) onFetchDevices();
  }, [visible]);

  const differentDevices = differenceBy(allDevices, devices, 'id');

  return (
    <Drawer
      width={264}
      title={<h2 className="cal-devices-list__title">{t('device-list')}</h2>}
      visible={visible}
      onClose={onClose}
    >
      <Button
        className="w-100"
        onClick={toggle}
        icon={<PlusOutlined />}
        type="primary"
      >
        {t('add-device')}
      </Button>
      <div className="cal-devices-list">
        {map(devices, (device, id) => (
          <CalendarDeviceItem
            {...device}
            t={t}
            onClick={onDelete}
            deleteAction
            key={id}
          />
        ))}
      </div>
      {!isEmpty(devices) && (
        <Popconfirm
          placement="top"
          title={t('are-you-sure')}
          cancelText={t('to-leave')}
          okText={t('delete')}
          onConfirm={onDeleteAllDevices}
        >
          <Button className="w-100" type="danger" ghost>
            {t('remove-everything-from-calendar')}
          </Button>
        </Popconfirm>
      )}
      <AddDevicesDrawer
        t={t}
        isOpen={isOpen}
        toggle={toggle}
        devices={differentDevices}
        onAdd={onAdd}
        filters={filters}
        onSearch={onSearch}
        onFilter={onFilter}
        filter={filter}
      />
    </Drawer>
  );
}

export default CalendarDevicesList;
